import React from 'react'
import { Link } from 'gatsby'
import Stack from 'react-bootstrap/Stack'
import Card from 'react-bootstrap/Card'
import PriceDisplay from './price-display'
import PercentageOff from './percentage-off'
import useGetPrice from '../hooks/useGetPrice'
import setQueryParams from '../utilities/setQueryParams'
import Badge from './badge'

const HEIGHT = 80
const BADGE_OFFSET = 4

export default function ProductCardMini({ product, onClick, children }) {
    const {
        name,
        shortDescription,
        url,
        category,
        includes,
        image,
        badge,
    } = product || {}

    const BORDER_RADIUS = 0
    const is_collection = includes?.length > 0
    const { price } = useGetPrice(product)

    if (!product) return
    return (
        <Link
            to={url}
            className="d-flex bg-white text-decoration-none h-100"
            css={{ '&:hover': { transform: 'scale(1.02)' }}}
            onClick={onClick}
            style={{
                gridColumn: 'span 1',
                transition: 'transform .25s ease',
                borderRadius: BORDER_RADIUS,
            }}
        >
            {/* IMAGE AND BADGE */}
            <div className='position-relative'>
                <img
                    src={setQueryParams(image, { format: 'webp', width: HEIGHT*2 })}
                    alt=''
                    style={{
                        borderTopLeftRadius: BORDER_RADIUS,
                        width: HEIGHT,
                        height: HEIGHT,
                    }}
                />

                {(badge || price?.promotion_price) && (
                    <Badge
                        style={{
                            top: HEIGHT,
                            left: -BADGE_OFFSET,
                            width: HEIGHT + BADGE_OFFSET,
                        }}
                    >
                        {badge ? badge :
                        <><PercentageOff price={price} />% OFF</>}
                    </Badge>
                )}
            </div>

            {/* TITLE, CATEGORY, DESCRIPTION, INCLUDES/REQUIRES, PRICE */}
            <Card
                className="border-0"
                style={{
                    padding: 16,
                    borderRadius: 0,
                }}
            >
                <Card.Body className="p-0">
                    <Card.Title
                        className="poppins fw-bold"
                        style={{
                            fontSize: 20,
                            lineHeight: '121%',
                            marginBottom: 8,
                        }}
                    >
                        {name}
                    </Card.Title>

                    <Card.Subtitle
                        as='p'
                        className="fw-semibold text-uppercase text-secondary"
                        style={{ marginBottom: 8 }}
                    >
                        {category?.slice(0, -1)}
                    </Card.Subtitle>

                    <Card.Text
                        dangerouslySetInnerHTML={{ __html: shortDescription }}
                        className='clamp-2'
                        css={{ '& p': { marginBottom: 0 }}}
                        style={{ fontSize: 14, marginBottom: 8 }}
                    />
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 p-0">
                    <Stack direction="horizontal" className="justify-content-between">
                        <PriceDisplay
                            product={product}
                            style={{ fontSize: 18, fontWeight: 600 }}
                            className='d-flex align-items-center gap-2'
                        />
                        {is_collection && (
                            <img
                                src='/svg/is-collection-icon-black.svg' alt=''
                                title='Type: Collection'
                            />
                        )}
                    </Stack>
                </Card.Footer>
            </Card>
        </Link>
    )
}
